import { useMemo } from 'react'
import { IMDMUnit, IMDMUnitInstance } from '@/pages/MDM/mdm.types.ts'
import useUnitInstances from '@/pages/MDM/hooks/useUnitInstances.ts'
import DropdownInput from 'src/shared/Inputs/DropdownInput'

interface IProps {
  unitId: IMDMUnit['id']
  value: IMDMUnitInstance['id']
  name: string
  onChange: (val: IMDMUnitInstance['id'], name: string) => void
  placeHolder?: string
}

const UnitInstanceDropdown = (props: IProps) => {
  const instances = useUnitInstances()
  const filteredInstances = useMemo(() => {
    return instances.filter((i) => i.unitId === props.unitId)
  }, [props.unitId, instances])

  const options = useMemo(() => {
    return filteredInstances.map((v) => ({ title: v.name, value: v.id }))
  }, [filteredInstances])

  return (
    <DropdownInput
      options={options}
      name={props.name}
      selectedOption={props.value as any}
      title={props.placeHolder || 'Выберите значение'}
      onSelect={props.onChange}
    />
  )
}

export default UnitInstanceDropdown
